;(function ($) {
    'use strict';
    $(document).ready(function () {

        // hit configurator api and set initial options.
        if (!('bulkUpload' in window)) {
            updateConfiguratorFields();
        }

        // Drop-down file upload field.
        $('.file-upload').on('click', function (e) {
            e.preventDefault();
            $(this).next('.drawer').slideToggle();
        });

        // Show part identifiers.
        $(document).on('click', '.add-identifier', function (e) {
            $(this).next('.additional-info-container-wrapper').toggle();
        });

        $(document).on('change', '#graphimator_form .option', function (e) {
            if ($(this).find(':selected').attr('class') === 'inactive') {
                $(this).css('color', '#B6BBC3');
            } else {
                $(this).css('color', '#02203F');
            }

            const productUpdated = this.dataset.option === 'product';

            if (productUpdated && !loggedIn) {
                alert('This is just a demo')
            }

            // Submit fields to configurator and update fields with response.
            updateConfiguratorFields(productUpdated);
        });

        // Wait a number of seconds after typing in dimensions and then update.
        let timer;
        const timerInterval = 1000;
        $(document).on('input', '.dimension', function () {
            clearTimeout(timer);
            timer = setTimeout(updateConfiguratorFields, timerInterval);
        });

        $(document).on('input', '#quantity', function () {
            clearTimeout(timer);
            timer = setTimeout(updateConfiguratorFields, timerInterval);
        });

        // Add item to cart.
        $('.add-to-cart').on('click', function (e) {
            e.preventDefault();

            addToCart();
        });

        // Toggle part identifiers.
        $('.add-identifier').on('click', function () {
            if ($(this).hasClass('active')) {
                // unset values and hide
                $(this).removeClass('active');
                $('.additional-info-container input').val('');
            } else {
                $(this).addClass('active');
            }
        });

        for (const reference of $('.references-toggle')) {
            if (!$(reference).is(':checked')) {
                $(`.references-container[data-item="${reference.dataset.item}"]`).slideUp();
            }
        }

        $('.references-toggle').on('click', function () {
            $(`.references-container[data-item="${this.dataset.item}"]`).slideToggle();
        });

        if ('bulkUpload' in window) {
            for (let i = 1; i <= bulkUpload; i++) {
                updateBulkUploadOptions(i);
            }
        }

        $(document).on('input', '.dimension-bulk', function () {
            clearTimeout(timer);
            timer = setTimeout(updateBulkUploadOptions.bind(this, this.dataset.item), timerInterval);
        });

        $(document).on('change', '#bulk_upload_form .product-select', function (e) {
            const itemId = this.dataset.item;
            $(`.added-option[data-item='${itemId}']`).remove();
            updateBulkUploadOptions(itemId, this.value);
        });

        $(document).on('change', '#bulk_upload_form .option', function (e) {
            const itemId = this.dataset.item;
            updateBulkUploadOptions(itemId);
        });

        $(document).on('input', '.quantity-input', function () {
            clearTimeout(timer);
            timer = setTimeout(updateBulkUploadOptions.bind(this, this.dataset.item), timerInterval);
        })

        $('.remove-item').on('click', function () {
            $(`.line-item[data-item="${this.dataset.item}"]`).remove();
        });

        $('.product-type-select').on('change', function () {
            const graphimatorItems = $(`.graphimator[data-item="${this.dataset.item}"]`);
            const specialItems = $(`.special[data-item="${this.dataset.item}"]`);

            if (this.value === 'special_product') {
                graphimatorItems.addClass('hidden');
                specialItems.removeClass('hidden');

                $(`.special[data-item="${this.dataset.item}"] select[name="${this.dataset.item}[lead_time]"]`).prop('required', true);

                // if special product squares selected.
                const product = $(`#product_${this.dataset.item}`).val();

                if (product === '1') {
                    const material = $(`#material_${this.dataset.item} option:selected`).text();
                    $(`.special .material-name[data-item="${this.dataset.item}"]`).val(material);

                    // get the tolerance and set dimension precisions.
                    const tolerance = $(`#tolerance_${this.dataset.item} option:selected`).text();

                    const precisionX = $(`.x-precision select[data-item="${this.dataset.item}"]`);
                    const precisionY = $(`.y-precision select[data-item="${this.dataset.item}"]`);
                    const precisionZ = $(`.z-precision select[data-item="${this.dataset.item}"]`);

                    const sawCut = '[+.1000/-.0000]';
                    const lightGrind = '[+.0100/-.0000]';
                    const precision = '[+.0010/-.0010]';

                    if (tolerance === 'Light Grind X') {
                        precisionX.val('lt-grind');
                        precisionY.val('saw-cut');
                        precisionZ.val('saw-cut');
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label label`).text(lightGrind);
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label input`).val(lightGrind);
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label label`).text(sawCut);
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label input`).val(sawCut);
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label label`).text(sawCut);
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label input`).val(sawCut);
                    } else if (tolerance === 'Light Grind Y') {
                        precisionY.val('lt-grind');
                        precisionX.val('saw-cut');
                        precisionZ.val('saw-cut');
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label label`).text(lightGrind);
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label input`).val(lightGrind);
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label label`).text(sawCut);
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label input`).val(sawCut);
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label label`).text(sawCut);
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label input`).val(sawCut);
                    } else if (tolerance === 'Light Grind Z') {
                        precisionZ.val('lt-grind');
                        precisionY.val('saw-cut');
                        precisionX.val('saw-cut');
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label label`).text(lightGrind);
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label input`).val(lightGrind);
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label label`).text(sawCut);
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label input`).val(sawCut);
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label label`).text(sawCut);
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label input`).val(sawCut);
                    } else if (tolerance === 'Precision X') {
                        precisionX.val('precision');
                        precisionY.val('saw-cut');
                        precisionZ.val('saw-cut');
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label label`).text(precision);
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label input`).val(precision);
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label label`).text(sawCut);
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label input`).val(sawCut);
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label label`).text(sawCut);
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label input`).val(sawCut);
                    } else if (tolerance === 'Precision Y') {
                        precisionY.val('precision');
                        precisionX.val('saw-cut');
                        precisionZ.val('saw-cut');
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label label`).text(precision);
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label input`).val(precision);
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label label`).text(sawCut);
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label input`).val(sawCut);
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label label`).text(sawCut);
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label input`).val(sawCut);
                    } else if (tolerance === 'Precision Z') {
                        precisionZ.val('precision');
                        precisionY.val('saw-cut');
                        precisionX.val('saw-cut');
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label label`).text(precision);
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label input`).val(precision);
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label label`).text(sawCut);
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label input`).val(sawCut);
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label label`).text(sawCut);
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label input`).val(sawCut);
                    } else if (tolerance === 'Saw-Cut X') {
                        precisionX.val('saw-cut');
                        precisionY.val('precision');
                        precisionZ.val('precision');
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label label`).text(sawCut);
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label input`).val(sawCut);
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label label`).text(precision);
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label input`).val(precision);
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label label`).text(precision);
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label input`).val(precision);
                    } else if (tolerance === 'Saw-Cut Y') {
                        precisionX.val('precision');
                        precisionY.val('saw-cut');
                        precisionZ.val('precision');
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label label`).text(sawCut);
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label input`).val(sawCut);
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label label`).text(precision);
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label input`).val(precision);
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label label`).text(precision);
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label input`).val(precision);
                    } else if (tolerance === 'Saw-Cut Z') {
                        precisionZ.val('saw-cut');
                        precisionY.val('precision');
                        precisionX.val('precision');
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label label`).text(sawCut);
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label input`).val(sawCut);
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label label`).text(precision);
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label input`).val(precision);
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label label`).text(precision);
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label input`).val(precision);
                    } else if (tolerance === 'Saw-Cut') {
                        precisionX.val('saw-cut');
                        precisionY.val('saw-cut');
                        precisionZ.val('saw-cut');
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label label`).text(sawCut);
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label input`).val(sawCut);
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label label`).text(sawCut);
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label input`).val(sawCut);
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label label`).text(sawCut);
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label input`).val(sawCut);
                    } else if (tolerance === 'Precision Ground') {
                        precisionX.val('precision');
                        precisionY.val('precision');
                        precisionZ.val('precision');
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label label`).text(precision);
                        $(`.x-radio[data-item="${this.dataset.item}"] .radio-label input`).val(precision);
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label label`).text(precision);
                        $(`.y-radio[data-item="${this.dataset.item}"] .radio-label input`).val(precision);
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label label`).text(precision);
                        $(`.z-radio[data-item="${this.dataset.item}"] .radio-label input`).val(precision);
                    }

                    updateSpecialProductDescription.bind(this)(true);

                    const category = $(`#category_${this.dataset.item}`).val();
                    const selectedMaterial = $(`#material_${this.dataset.item}`).val();
                    const selectedTolerance = $(`#tolerance_${this.dataset.item}`).val();

                    // send for price geometry, cat, mat, tol, qty, x, y, z
                    const selectedOptions = [1, category, selectedMaterial, selectedTolerance];

                    const dimensionX = $(`#dimension_${this.dataset.item}_x`).val();
                    const dimensionY = $(`#dimension_${this.dataset.item}_y`).val();
                    const dimensionZ = $(`#dimension_${this.dataset.item}_z`).val();

                    const selectedDimensions = {
                        x: dimensionX,
                        y: dimensionY,
                        z: dimensionZ,
                    };

                    const quantity = $(`.special-quantity-input[data-item="${this.dataset.item}"]`).val();

                    $.post({
                        url: '/api/configurator',
                        dataType: 'json',
                        contentType: 'application/json',
                        data: JSON.stringify(
                            {
                                options: selectedOptions,
                                dimensions: selectedDimensions,
                                quantity: quantity,
                            }
                        ),
                        success: (response) => {
                            console.log('resp', response);
                            $(`.special .labor-price[data-item="${this.dataset.item}"]`).val('$' + response.price.labor_each);
                            $(`.special .material-price[data-item="${this.dataset.item}"]`).val('$' + response.price.material_each);
                            $(`.special-prices-container-${this.dataset.item} .unit`).text('$' + response.price.each);
                            $(`.special-prices-container-${this.dataset.item} .total`).text('$' + response.price.total);

                            updateSpecialProductDescription.bind(this)();
                        },
                        error: err => {
                            handleError(err);
                        }
                    });
                }
            } else {
                graphimatorItems.removeClass('hidden');
                specialItems.addClass('hidden');
                $(`.special[data-item="${this.dataset.item}"] select[name="${this.dataset.item}[lead_time]"]`).prop('required', false);
            }

            $(`.y-dimension-rnd`).addClass('hidden');
            $('.y-precision-rnd').addClass('hidden');
            $('.x-precision-rnd').addClass('hidden');
            $('.z-precision-rnd').addClass('hidden');
            $('.other-tol-x').addClass('hidden');
            $('.other-tol-y').addClass('hidden');
            $('.other-tol-z').addClass('hidden');
        });

        $('#bulk_upload_form .special .geometry').on('change', function () {
            const id = this.dataset.item;

            $(`.x-precision[data-item="${id}"]`).addClass('hidden');
            $(`.y-precision[data-item="${id}"]`).addClass('hidden');
            $(`.z-precision[data-item="${id}"]`).addClass('hidden');
            $(`.radio-select-container[data-item="${id}"]`).addClass('hidden');
            $(`.y-precision[data-item="${id}"]`).css('opacity', 1);
            $(`.y-radio[data-item="${id}"]`).css('opacity', 1);
            $(`.y-dimension-rnd[data-item="${id}"]`).addClass('hidden');
            $(`.x-precision-rnd[data-item="${id}"]`).addClass('hidden');
            $(`.z-precision-rnd[data-item="${id}"]`).addClass('hidden');
            $('.other-tol-x').addClass('hidden');
            $('.other-tol-y').addClass('hidden');
            $('.other-tol-z').addClass('hidden');
            $('.custom-x').addClass('hidden');
            $('.custom-y').addClass('hidden');
            $('.custom-z').addClass('hidden');

            if (this.value === '1') {
                // square
                $(`.x-precision[data-item="${id}"]`).removeClass('hidden');
                $(`.y-precision[data-item="${id}"]`).removeClass('hidden');
                $(`.z-precision[data-item="${id}"]`).removeClass('hidden');
                $(`.y-dimension[data-item="${id}"]`).removeClass('hidden');
                $(`.x-radio[data-item="${id}"]`).removeClass('hidden');
                $(`.y-radio[data-item="${id}"]`).removeClass('hidden');
                $(`.z-radio[data-item="${id}"]`).removeClass('hidden');

                $(`.x-radio[data-item="${id}"] .radio-label input`).val('[+.1000/-.0000]');
                $(`.x-radio[data-item="${id}"] .radio-label label`).text('[+.1000/-.0000]');
                $(`.y-radio[data-item="${id}"] .radio-label input`).text('[+.1000/-.0000]');
                $(`.y-radio[data-item="${id}"] .radio-label label`).text('[+.1000/-.0000]');
                $(`.z-radio[data-item="${id}"] .radio-label input`).val('[+.1000/-.0000]');
                $(`.z-radio[data-item="${id}"] .radio-label label`).text('[+.1000/-.0000]');
            } else if (this.value === '2') {
                // rounds
                $('.x-precision-rnd').removeClass('hidden');
                $('.z-precision-rnd').removeClass('hidden');

                $(`.y-dimension[data-item="${id}"]`).addClass('hidden');
                $(`.y-dimension-rnd[data-item="${id}"]`).removeClass('hidden');
                $(`.y-precision[data-item="${id}"]`).removeClass('hidden');
                $(`.y-precision[data-item="${id}"]`).css('opacity', 0);
                $(`.x-radio[data-item="${id}"]`).removeClass('hidden');
                $(`.y-radio[data-item="${id}"]`).removeClass('hidden');
                $(`.y-radio[data-item="${id}"]`).css('opacity', 0);
                $(`.z-radio[data-item="${id}"]`).removeClass('hidden');

                $(`.x-radio[data-item="${id}"] .radio-label input`).val('[+.0100/-.0000]');
                $(`.x-radio[data-item="${id}"] .radio-label label`).text('[+.0100/-.0000]');

                $(`.z-radio[data-item="${id}"] .radio-label input`).val('[+.1000/-.0000]');
                $(`.z-radio[data-item="${id}"] .radio-label label`).text('[+.1000/-.0000]');
            } else if (this.value === '5') {
                // other
                $(`.y-dimension[data-item="${id}"]`).removeClass('hidden');
                $(`.y-dimension-rnd[data-item="${id}"]`).addClass('hidden');
                $(`.other-tol-x[data-item="${id}"]`).removeClass('hidden');
                $(`.other-tol-y[data-item="${id}"]`).removeClass('hidden');
                $(`.other-tol-z[data-item="${id}"]`).removeClass('hidden');
            }
        });

        $('.radio-select-container input').on('change', function () {
            const customInput = $(`.other-container > .custom-${this.dataset.selected}[data-item="${this.dataset.item}"]`);

            if (this.value === 'other') {
                customInput.removeClass('hidden');
            } else {
                customInput.addClass('hidden');
            }
        });

        $('#bulk_upload_form .special :input').change(updateSpecialProductDescription);
        $('#bulk_upload_form .special :input').keyup(updateSpecialProductDescription);

        $('#bulk_upload_form .special :input').change(updateSpecialProductFields);
        $('#bulk_upload_form .special :input').keyup(updateSpecialProductFields);

        $('.x-precision select').on('change', function () {
            const radioEl = $(`.x-radio[data-item="${this.dataset.item}"] .radio-label input`);
            const radioLabel = $(`.x-radio[data-item="${this.dataset.item}"] .radio-label label`);

            let tolerance;
            if (this.value === 'saw-cut') {
                tolerance = '[+.1000/-.0000]';
            } else if (this.value === 'lt-grind') {
                tolerance = '[+.0100/-.0000]';
            } else if (this.value === 'precision') {
                tolerance = '[+.0002/-.0002]';
            }

            radioEl.val(tolerance);
            radioEl.prop('checked', true);
            radioLabel.text(tolerance);
        });

        $('.y-precision select').change(function () {
            const radioEl = $(`.y-radio[data-item="${this.dataset.item}"] .radio-label input`);
            const radioLabel = $(`.y-radio[data-item="${this.dataset.item}"] .radio-label label`);

            let tolerance;
            if (this.value === 'saw-cut') {
                tolerance = '[+.1000/-.0000]';
            } else if (this.value === 'lt-grind') {
                tolerance = '[+.0100/-.0000]';
            } else if (this.value === 'precision') {
                tolerance = '[+.0002/-.0002]';
            }

            radioEl.val(tolerance);
            radioEl.prop('checked', true);
            radioLabel.text(tolerance);
        });

        $('.z-precision select').change(function () {
            const radioEl = $(`.z-radio[data-item="${this.dataset.item}"] .radio-label input`);
            const radioLabel = $(`.z-radio[data-item="${this.dataset.item}"] .radio-label label`);

            let tolerance;
            if (this.value === 'saw-cut') {
                tolerance = '[+.1000/-.0000]';
            } else if (this.value === 'lt-grind') {
                tolerance = '[+.0100/-.0000]';
            } else if (this.value === 'precision') {
                tolerance = '[+.0002/-.0002]';
            }

            radioEl.val(tolerance);
            radioEl.prop('checked', true);
            radioLabel.text(tolerance);
        });

        $('#bulk_upload_form .submit').on('click', function (e) {
            const itemError = $('.line-item.error');
            if (itemError.length) {
                e.preventDefault();
                alert('Item ' + itemError[0].dataset.item + ' is invalid');
            }
        });
    });
})(jQuery, window, document);

function updateSpecialProductFields() {
    const product = $(`.geometry[data-item="${this.dataset.item}"] option:selected`).val();

    if (product !== '1') {
        return;
    }

    // need to get the value entered for material, and match it to the now hidden graphimator material field..
    const material = $(`.special .material-name[data-item="${this.dataset.item}"]`).val();
    let selectedMaterial;
    for (const mat of $(`#material_${this.dataset.item} option`)) {
        if (material === $(mat).text()) {
            selectedMaterial = $(mat).val();
        }
    }

    // get the tolerance and set dimension precisions.
    const precisionX = $(`.x-precision select[data-item="${this.dataset.item}"]`);
    const precisionY = $(`.y-precision select[data-item="${this.dataset.item}"]`);
    const precisionZ = $(`.z-precision select[data-item="${this.dataset.item}"]`);

    let category;
    let tolerance;
    if (precisionX.val() === 'lt-grind' && precisionY.val() === 'saw-cut' && precisionZ.val() === 'saw-cut') {
        // light grind x
        category = 73;
        tolerance = 83;
    } else if (precisionY.val() === 'lt-grind' && precisionX.val() === 'saw-cut' && precisionZ.val() === 'saw-cut') {
        // light grind y
        category = 73;
        tolerance = 84;
    } else if (precisionZ.val() === 'lt-grind' && precisionY.val() === 'saw-cut' && precisionX.val() === 'saw-cut') {
        // light grind z
        category = 73;
        tolerance = 85;
    } else if (precisionX.val() === 'precision' && precisionY.val() === 'saw-cut' && precisionZ.val() === 'saw-cut') {
        // precision x
        category = 74;
        tolerance = 86;
    } else if (precisionY.val() === 'precision' && precisionX.val() === 'saw-cut' && precisionZ.val() === 'saw-cut') {
        // precision y
        category = 74;
        tolerance = 87;
    } else if (precisionZ.val() === 'precision' && precisionY.val() === 'saw-cut' && precisionX.val() === 'saw-cut') {
        // precision z
        category = 74;
        tolerance = 88;
    } else if (precisionX.val() === 'saw-cut' && precisionY.val() === 'precision' && precisionZ.val() === 'precision') {
        // saw-cut x
        category = 77;
        tolerance = 91;
    } else if (precisionX.val() === 'precision' && precisionY.val() === 'saw-cut' && precisionZ.val() === 'precision') {
        // saw-cut y
        category = 77;
        tolerance = 92;
    } else if (precisionZ.val() === 'saw-cut' && precisionY.val() === 'precision' && precisionX.val() === 'precision') {
        // saw-cut z
        category = 77;
        tolerance = 93;
    } else if (precisionX.val() === 'saw-cut' && precisionY.val() === 'saw-cut' && precisionZ.val() === 'saw-cut') {
        // saw-cut
        category = 76;
        tolerance = 90;
    } else if (precisionX.val() === 'precision' && precisionY.val() === 'precision' && precisionZ.val() === 'precision') {
        // precision ground
        category = 75;
        tolerance = 89;
    }

    updateSpecialProductDescription.bind(this)();

    // send for price geometry, cat, mat, tol, qty, x, y, z
    const selectedOptions = [1, category, selectedMaterial, tolerance];

    const dimensionX = $(`#dimension_${this.dataset.item}_x`).val();
    const dimensionY = $(`#dimension_${this.dataset.item}_y`).val();
    const dimensionZ = $(`#dimension_${this.dataset.item}_z`).val();

    const selectedDimensions = {
        x: dimensionX,
        y: dimensionY,
        z: dimensionZ,
    };

    const quantity = $(`.special-quantity-input[data-item="${this.dataset.item}"]`).val();

    const drawingInput = $(`.drawing input[data-item="${this.dataset.item}"]`);
    const drawing = drawingInput.val();
    console.log('drawing', drawingInput, drawing);

    $.post({
        url: '/api/configurator',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(
            {
                options: selectedOptions,
                dimensions: selectedDimensions,
                quantity: quantity,
                drawing: drawing,
            }
        ),
        success: (response) => {
            console.log(response);
            $(`.special .labor-price[data-item="${this.dataset.item}"]`).val('$' + response.price.labor_each);
            $(`.special .material-price[data-item="${this.dataset.item}"]`).val('$' + response.price.material_each);
            $(`.special-prices-container-${this.dataset.item} .unit`).text('$' + response.price.each);
            $(`.special-prices-container-${this.dataset.item} .total`).text('$' + response.price.total);
        },
        error: err => {
            handleError(err);
        }
    });
}

function updateSpecialProductDescription(typeSwitched = false) {
    const geometry = $(`.geometry[data-item="${this.dataset.item}"]`).val();
    const descriptionContainer = $(`.special-product-description[data-item="${this.dataset.item}"] input`);
    const material = $(`.special .material-name[data-item="${this.dataset.item}"]`);

    let dimensionX;
    let dimensionY;
    let dimensionZ;
    let precisionX;
    let precisionY;
    let precisionZ;
    if (geometry === '1') {
        dimensionX = $(`.x-dimension[data-item="${this.dataset.item}"] input`);
        dimensionY = $(`.y-dimension[data-item="${this.dataset.item}"] input`);
        dimensionZ = $(`.z-dimension[data-item="${this.dataset.item}"] input`);
        precisionX = $(`.x-precision[data-item="${this.dataset.item}"] select`);
        precisionY = $(`.y-precision[data-item="${this.dataset.item}"] select`);
        precisionZ = $(`.z-precision[data-item="${this.dataset.item}"] select`);
    } else if (geometry === '2') {
        dimensionX = $(`.x-dimension[data-item="${this.dataset.item}"] input`);
        dimensionY = $(`.y-dimension-rnd[data-item="${this.dataset.item}"] input`);
        dimensionZ = $(`.z-dimension[data-item="${this.dataset.item}"] input`);
        precisionX = $(`.x-precision-rnd[data-item="${this.dataset.item}"] select option:selected`);
        precisionY = $(`.y-precision[data-item="${this.dataset.item}"] select option:selected`);
        precisionZ = $(`.z-precision-rnd[data-item="${this.dataset.item}"] select option:selected`);
    } else {
        dimensionX = $(`.x-dimension[data-item="${this.dataset.item}"] input`);
        dimensionY = $(`.y-dimension[data-item="${this.dataset.item}"] input`);
        dimensionZ = $(`.z-dimension[data-item="${this.dataset.item}"] input`);
        precisionX = $(`.other-tol-x[data-item="${this.dataset.item}"] input`);
        precisionY = $(`.other-tol-y[data-item="${this.dataset.item}"] input`);
        precisionZ = $(`.other-tol-z[data-item="${this.dataset.item}"] input`);
    }

    const drawing = $(`.drawing[data-item="${this.dataset.item}"] input`);

    let description = material.val();

    if (geometry === '2') {
        description += ' [' + dimensionX.val() + ' DIA x ' + dimensionZ.val() + '] ';
    } else {
        description += " [" + dimensionX.val() + " x " + dimensionY.val() + " x " + dimensionZ.val() + "] ";
    }

    description += drawing.val();

    let precision;
    let singlePrecision = false;
    let singlePrecisionValue;
    if (geometry === '1') {
        if (precisionX.val() && precisionX.val() === precisionY.val() && precisionY.val() === precisionZ.val()) {
            precision = ' [All Dimensions][All ' + precisionX.val() + ']';
        } else if (precisionX.val() === 'saw-cut' && precisionY.val() === precisionX.val()) {
            singlePrecision = 'z';
            singlePrecisionValue = precisionZ.val();
        } else if (precisionX.val() === 'saw-cut' && precisionZ.val() === precisionX.val()) {
            singlePrecision = 'y';
            singlePrecisionValue = precisionY.val();
        } else if (precisionY.val() === 'saw-cut' && precisionZ.val() === precisionY.val()) {
            singlePrecision = 'x';
            singlePrecisionValue = precisionX.val();
        }

        if (precision) {
            description += precision;
        } else if (singlePrecision) {
            if (singlePrecisionValue === 'lt-grind') {
                description += ' Coarse Ground [1-Dimension][Light Grind ' + singlePrecision.toUpperCase() + ']';
            } else if (singlePrecisionValue === 'precision') {
                description += ' Precision Ground [1-Dimension] [Precision ' + singlePrecision.toUpperCase() + ']';
            }
        }
    } else if (geometry === '2') {
        description += ' ' + precisionX.text() + ' Round ';

        description += '[' + precisionZ.text() + ' Ends]';
    } else {
        description += ' ' + precisionX.val() + ' ' + precisionY.val() + ' ' + precisionZ.val();
    }

    descriptionContainer.val(description);

    const quantity = parseInt($(`.special-quantity-input[data-item="${this.dataset.item}"]`).val());
    const laborInput = $(`.labor-price[data-item="${this.dataset.item}"]`);
    const laborPrice = parseFloat(laborInput.val().replace('$', ''));
    const materialInput = $(`.material-price[data-item="${this.dataset.item}"]`);
    const materialPrice = parseFloat(materialInput.val().replace('$', ''));

    let adjustment = 0;
    if (drawing.val() === 'w/Revision C NAL 3R' || drawing.val() === 'w/NAL Slotted Pattern') {
        adjustment = 5;
    }

    const each = laborPrice + materialPrice + adjustment;

    const prices = {
        each: each,
        total: each * quantity,
    }

    console.log('typeswitched', typeSwitched)
    if (prices.each && prices.total) {
        if (!typeSwitched) {
            $(`.special-prices-container-${this.dataset.item} .unit`).html('$' + prices.each.toFixed(2));
            $(`.special-prices-container-${this.dataset.item} .total`).html('$' + prices.total.toFixed(2));
        }

        $(`#bulk_upload_form .line-item[data-item="${this.dataset.item}"]`).removeClass('error');
    } else {
        $(`.special-prices-container-${this.dataset.item} .unit`).html('');
        $(`.special-prices-container-${this.dataset.item} .total`).html('');

        $(`#bulk_upload_form .line-item[data-item="${this.dataset.item}"]`).addClass('error');
    }
}

function updateBulkUploadOptions(itemId, productChanged = null) {
    // get the options
    let options = $(`#bulk_upload_form .option[data-item='${itemId}'], #bulk_upload_form .product-select[data-item='${itemId}']`).serializeArray();
    const dimensions = $(`.dimension-bulk[data-item="${itemId}"]`).serializeArray();
    const quantity = $(`.quantity-input[data-item="${itemId}"]`);

    let selectedOptions = [];
    let selectedDimensions = {};
    if (!productChanged) {
        for (const option of options) {
            selectedOptions.push(option.value);
        }

        for (const dimension of dimensions) {
            const key = dimension.name.replace(itemId + '[dimensions][', '').replace(']', '');
            selectedDimensions[key] = dimension.value;
        }
    } else {
        selectedOptions.push(productChanged);
    }

    $.post({
        url: '/api/configurator',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(
            {
                options: selectedOptions,
                dimensions: selectedDimensions,
                quantity: quantity[0].value,
            }
        ),
        success: (response) => {
            // remove the optionFields, and add the products options fields, with product values.
            // $(`.option-field[data-item='${itemId}']`).remove();
            // maybe only do this if the product was changed

            for (const option of response.options) {
                let currentOption = getConfiguratorOptionBySlug(option.configurator_option_slug, response.options);
                if (currentOption && option.configurator_option_values.length) {

                    const optionField = getOptionField(currentOption);
                    const optionElement = $('#' + option.configurator_option_slug + '_' + itemId);
                    optionField.setAttribute('id', option.configurator_option_slug + '_' + itemId);
                    optionField.setAttribute('name',  itemId + '[options][]');
                    optionField.setAttribute('data-item', itemId);

                    if (option.configurator_option_slug === 'product') {
                        optionField.setAttribute('class', 'product-select');
                    }

                    const currentValue = optionElement.val();
                    if (currentValue) {
                        optionField.value = optionElement.val();
                    }

                    if (optionElement.length) {
                        optionElement.replaceWith(optionField);
                    } else {
                        // need to add  fields after the quantity field and before the tolerances
                        const optionTemplate = `
                            <div class="shadow-label added-option" data-item="${itemId}">
                                <div class="label-text state-field">
                                    <label>
                                        ${option.configurator_option_title}:
                                        <select name="${itemId}[options][]" class="option" id="${option.configurator_option_slug}_${itemId}" data-option="${option.configurator_option_slug}" data-item="${itemId}">
                                           ${option.configurator_option_values.map(option => {
                                                return `
                                                  <option value='${option.configurator_option_value_id}'
                                                    data-token='${option.configurator_option_value_token}'
                                                    >
                                                    ${option.configurator_option_value_title}
                                                    </option>
                                                  `;
                                           }).join("")}
                                        </select>
                                    </label>
                                </div>
                                <div class="label-shadow">
                                </div>
                            </div>`;

                        // put the option template into options-cotainer
                        $(`.options-container .quantity-input-container[data-item='${itemId}']`).before(optionTemplate);
                    }
                } else {
                    $('#' + option.configurator_option_slug + '_' + itemId).closest('.shadow-label').remove();
                }
            }

            updateBulkDimensions(response.dimensions, itemId);

            if (productChanged) {
                $('.dimensions-input-container').html('');

                return updateBulkUploadOptions(itemId);
            }

            if (response.price) {
                updateBulkPrice(response.price, itemId);

                $(`#bulk_upload_form .line-item[data-item="${itemId}"]`).removeClass('error');
            } else {
                $(`#bulk_upload_form .line-item[data-item="${itemId}"]`).addClass('error');

                $(`.prices-container-${itemId} .unit`).html('Invalid configuration');
                $(`.prices-container-${itemId} .total`).html('');
            }
        },
        error: e => {
            handleError(e);
        }
    });
}

function updateBulkPrice(prices, itemId) {
    $(`.prices-container-${itemId} .unit`).html('$' + prices.each);
    $(`.prices-container-${itemId} .total`).html('$' + prices.total);
}

function getBulkDimensionField(item, dimensionLabel, dimensionValues) {
    // Create container element.
    const dimensionContainer = document.createElement('div');
    dimensionContainer.className = 'shadow-label';

    const innerContainer = document.createElement('div');
    innerContainer.className = 'label-text state-field';

    dimensionContainer.appendChild(innerContainer);

    // Create label.
    const label = document.createElement('label');
    label.innerHTML = dimensionLabel.replace(/\b\w/g, l => l.toUpperCase()) + ':';
    innerContainer.appendChild(label);

    // Create the input/select field.
    let fieldElement;
    let selectedOption;
    if (dimensionValues.type === 'field') {
        fieldElement = document.createElement('input');
        fieldElement.type = 'text';
    } else if (dimensionValues.type === 'select') {
        fieldElement = document.createElement('select');

        // set options and add to field element.
        for (const selectOption of Object.values(dimensionValues.values)) {
            let option = document.createElement('option');

            option.text = selectOption;
            option.value = selectOption;

            if (option.value.replace('"', '').replace('”', '') === dimensionValues.value) {
                selectedOption = option.value;
            }

            fieldElement.appendChild(option);
        }
    }

    if (dimensionValues.value) {
        if (selectedOption) {
            fieldElement.value = selectedOption;
        } else if (dimensionValues.value.includes('"') || dimensionValues.value.includes('”')) {
            fieldElement.value = dimensionValues.value;
        } else {
            fieldElement.value = parseFloat(dimensionValues.value).toFixed(4);
        }
    }

    fieldElement.name = item + "[dimensions][" + dimensionLabel + "]";
    fieldElement.id = 'dimension_' + item + '_' + dimensionLabel;
    fieldElement.className = 'dimension-bulk';
    fieldElement.dataset.item = item;

    label.appendChild(fieldElement);

    // Add cut type.
    if (dimensionValues.cut) {
        const cut = document.createElement('div');
        cut.innerText = dimensionValues.cut;
        cut.className = 'cut';

        dimensionContainer.appendChild(cut);
    }

    // Add tolerance
    if (dimensionValues.tolerance) {
        const tolerance = document.createElement('div');
        tolerance.innerText = dimensionValues.tolerance;
        tolerance.className = 'tolerance';

        dimensionContainer.appendChild(tolerance);
    }

    // Add error message.
    if (dimensionValues.error) {
        const error = document.createElement('p');
        error.className = 'error';
        error.innerText = dimensionValues.message;

        dimensionContainer.appendChild(error);
    }

    return dimensionContainer;
}

function updateBulkDimensions(dimensions, item) {
    const dimensionsContainer = $('#dimensions_container_' + item);

    if (dimensions) {
        let fields = [];
        for(const dimension of Object.keys(dimensions)) {
            if (dimensions[dimension] === null) continue;

            fields.push(getBulkDimensionField(item, dimension, dimensions[dimension]));
        }

        dimensionsContainer.html(fields);
    }
}

function getConfiguratorOptionBySlug(slug, options) {
    for (const optionValue of Object.values(options)) {
        if (optionValue.configurator_option_slug === slug) {
            return optionValue;
        }
    }
}


function updateConfiguratorFields(productUpdated = false) {
    const focusedElement = document.activeElement;

    let form = $('#graphimator_form').formObject()

    if (productUpdated) {
        form = {
            options: [form.options[0]]
        }
    }

    $.post({
        url: '/api/configurator',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(
            form
        ),
        success: (response) => {

            // update options
            updateOptions(response.options);

            // set quantity
            if (response.quantity) {
                updateQuantity(response.quantity);
            }

            // set dimensions
            updateDimensions(response.dimensions);

            // if there is pricing info, show the price & lead time card and set values.
            updatePriceInfo(response.price);

            const leadTimeContainer = $('.lead-time');
            if (response.lead_time) {
                leadTimeContainer.css('visibility', 'visible');
                $('#lead_time').html(response.lead_time);
            } else {
                leadTimeContainer.css('visibility', 'hidden');
            }

            const infoRow = $('.pricing-container .info-row');
            if (!response.lead_time && response.price && !response.price.stock) {
                infoRow.css('visibility', 'hidden');
            } else {
                infoRow.css('visibility', 'visible');
            }

            if (focusedElement.id) {
                $('#' + focusedElement.id).focus();
            }
        },
        error: e => {
            handleError(e);
        }
    });
}

let selectedConfiguratorProduct;
function updateOptions(options) {
    const optionContainer = $('#graphimator_options');

    const previousOptions = $('#graphimator_options .option');

    optionContainer.html('')

    let fields = [];
    for(const option of options) {
        if (option.configurator_option_values.length) {
            fields.push(getOptionField(option));
        }
    }

    optionContainer.html(fields);

    const urlParams = new URLSearchParams(window.location.search);
    let materialId = urlParams.get('material');

    // loop through updated options and check if the option exists, if so, check if the choice value exists.
    let optionSelected = false;
    optionLoop:
    for (const option of $('#graphimator_options .option')) {
        if (previousOptions.length === 0 && materialId && option.dataset.option === 'material') {
            const materialOption = $(option).find('option[value=' + materialId + ']');
            $(option).css('color', '#02203F');
            materialOption.prop('selected', true);
        }

        for (const previousOption of previousOptions) {
            if (option.dataset.option === previousOption.dataset.option) {
                // check if the value is a choice.
                for (const choice of $(option).find('option')) {
                    if (choice.value === previousOption.value && choice.value !== '') {
                        option.value = previousOption.value;
                        $(option).css('color', '#02203F')
                        optionSelected = true;

                        let selectedIndex = option.selectedIndex;
                        let selected = option.options[selectedIndex].text;
                        if (option.dataset.option === 'product') {
                            selectedConfiguratorProduct = selected;

                            let img;
                            if (selected.includes('Rounds')) {
                                img = '/assets/img/graphimator/graphite_round.jpg';
                            } else if (selected.includes('Square')) {
                                img = '/assets/img/graphimator/graphite_square.png';
                            } else if (selected.includes('Hexagon')) {
                                img = '/assets/img/graphimator/graphite_hexagons.jpg';
                            } else if (selected.includes('Graphite Tapping')) {
                                img = '/assets/img/graphimator/tapping-electrodes-3.png';
                            }

                            if (img) {
                                $('#graphimator_form .image-container').html('<img src="' + img + '" />');
                            } else {
                                $('#graphimator_form .image-container').html('');
                            }
                        }

                        if (option.dataset.option === 'material' && selectedConfiguratorProduct === 'EDM Tubes') {
                            let img;
                            if (selected.includes('Brass EDM Tubes')) {
                                img = '/assets/img/graphimator/brass-tube-4.png';
                            } else if (selected.includes('Copper EDM Tubes')) {
                                img = '/assets/img/graphimator/copper-tube-4.png';
                            }

                            if (img) {
                                $('#graphimator_form .image-container').html('<img src="' + img + '" />');
                            } else {
                                $('#graphimator_form .image-container').html('');
                            }
                        }

                        if (option.dataset.option === 'pattern') {
                            let img;
                            let pdf;
                            if (selected.includes('3R 30mm slotted holder')) {
                                img = '/assets/img/graphimator/QCE System3R 30mm Slotted.png';
                                pdf = '/assets/img/graphimator/3R-30-mm-Slotted.PDF';
                            } else if (selected.includes('3R 54mm holder')) {
                                img = '/assets/img/graphimator/QCE System3R 54 MM.png';
                                pdf = '/assets/img/graphimator/3R-54-mm-Pattern.PDF';
                            } else if (selected.includes('Erowa 20mm slotted holder')) {
                                img = '/assets/img/graphimator/QCE Erowa 20mm Slotted.png';
                                pdf = '/assets/img/graphimator/Erowa-20-mm-Slotted.PDF';
                            } else if (selected.includes('Erowa 50mm holder')) {
                                img = '/assets/img/graphimator/QCE Erowa 50 mm.png';
                                pdf = '/assets/img/graphimator/Erowa-50-mm-Pattern.PDF';
                            }

                            if (img) {
                                $('#graphimator_form .image-container').html('<img src="' + img + '" /> <a target="_blank" href="' + pdf + '" class="btn btn-primary">View PDF</a>');
                            } else {
                                $('#graphimator_form .image-container').html('');
                            }
                        }
                    }
                }

               continue optionLoop;
            }
        }
    }

    if (!optionSelected) {
        $('#graphimator_form .image-container').html('<p class="select-notice">SELECT OPTIONS TO THE LEFT TO BEGIN BUILDING YOUR PRODUCT</p>');
    } else {
        $('#graphimator_form .image-container .select-notice').remove();
    }
}


function getOptionField(option) {
    const field = document.createElement('select');

    Object.assign(field, {
        id: option.configurator_option_slug,
        name: 'options',
        className: 'option',
    });

    field.dataset.option = option.configurator_option_slug;

    const defaultOption = document.createElement('option');

    defaultOption.text = 'Select ' + option.configurator_option_title;
    defaultOption.className = 'inactive';
    defaultOption.value = '';

    field.appendChild(defaultOption);

    for (const configuratorOption of option.configurator_option_values) {
        if (configuratorOption.configurator_option_slug === 'material' && configuratorOption.material_status === 'Inactive') {
            continue;
        }
        
        let optionElement = document.createElement('option');

        optionElement.text = configuratorOption.configurator_option_value_title;
        optionElement.value = configuratorOption.configurator_option_value_id;

        field.appendChild(optionElement);
    }

    return field;
}


function updateQuantity(quantity) {
    $('#quantity').val(quantity);
}


function updateDimensions(dimensions) {
    const dimensionsContainer = $('#dimensions_container');
    const quantityElement = $('#quantity');
    const quantityValue = quantityElement.val() ? quantityElement.val() : '';

    // If no dimensions, hide the dimensions portion of the card.
    const productSelect = document.getElementById('product');
    const product = productSelect.options[productSelect.selectedIndex].text;
    if (!dimensions) {
        if (!selectedConfiguratorProduct) {
            selectedConfiguratorProduct = product;
        }

        $('.dimensions-container').slideUp();
    } else {
        $('.dimensions-container').slideDown();
    }

    const previousDimensions = $('.dimension-field');

    // dimensionsContainer.html('')

    if (dimensions) {
        let fields = [];
        for(const dimension of Object.keys(dimensions)) {
            if (dimensions[dimension] === null) continue;

            fields.push(getDimensionField(dimension, dimensions[dimension]));
        }

        dimensionsContainer.html(fields);
    }

    const quantityInput = `
        <p class="label">
            Quantity:
        </p>

        <input type="text" id="quantity" name="quantity" aria-label="Quantity" value="${quantityValue}" />
    `;

    const dimensionDiameter = dimensionsContainer.find('#dimension_diameter');

    const quantityField = `<div class="dimension quantity-field">${quantityInput}</div>`;

    dimensionLoop:
    for (const dimension of $('.dimension-field')) {
        for (const previousDimension of previousDimensions) {
            if (dimension.name === previousDimension.name) {
                if (previousDimension.value) {
                    if (previousDimension.value.includes('"') || previousDimension.value === 'No' || previousDimension.value === 'Yes') {
                        dimension.value = previousDimension.value;
                    } else {
                        dimension.value = parseFloat(previousDimension.value).toFixed(4)
                    }
                }

                continue dimensionLoop;
            }
        }
    }

    document.querySelector('.quantity-card').dataset.selected = selectedConfiguratorProduct;

    if (selectedConfiguratorProduct.includes('Hex')) {
        dimensionDiameter.prev('.label').text('Hex Size')
    }

    if (dimensionDiameter) {
        dimensionsContainer.prepend(dimensionDiameter.parent());
    }

    if (
        selectedConfiguratorProduct.includes('Squares')
        || selectedConfiguratorProduct.includes('Rectangle')
        || selectedConfiguratorProduct.includes('Quick Change')
        || selectedConfiguratorProduct.includes('EDM')
        || selectedConfiguratorProduct.includes('Tapping')
    ) {
        // make sure the quantity field is added to quantity-container
        if (!document.querySelector('.quantity-container #quantity')) {
            $('.quantity-container').html(quantityInput);
        }
        $('.quantity-field').remove();
    } else {
        $('.quantity-container').html('');
        if (!$('.quantity-field').length) {
            $('#dimensions_container').append(quantityField)
        }
    }
}


function getDimensionField(dimensionLabel, dimensionValues) {
    // Create container element.
    const dimensionContainer = document.createElement('div');
    dimensionContainer.className = 'dimension';

    // Create label.
    const label = document.createElement('p');
    const mobileLabel = '<span class="mobile">Dimensions (inches):</span> ';

    if (dimensionLabel === 'flush-hole-dia') {
        label.innerHTML = mobileLabel + 'Flush Hole DIA'.replace(/\b\w/g, l => l.toUpperCase());
    } else if (dimensionLabel === 'shank-dia') {
        label.innerHTML = mobileLabel + 'Shank DIA'.replace(/\b\w/g, l => l.toUpperCase());
    } else {
        label.innerHTML = mobileLabel + dimensionLabel.replace(/\b\w/g, l => l.toUpperCase());
    }

    label.className = 'label';
    dimensionContainer.appendChild(label);

    // Create the input/select field.
    let fieldElement;
    if (dimensionValues.type === 'field') {
        fieldElement = document.createElement('input');
        fieldElement.type = 'text';
    } else if (dimensionValues.type === 'select') {
        fieldElement = document.createElement('select');

        // set options and add to field element.
        for (const selectOption of Object.values(dimensionValues.values)) {
            let option = document.createElement('option');
            option.text = selectOption;
            option.value = selectOption;

            fieldElement.appendChild(option);
        }
    }

    if (dimensionValues.value) {
        if (dimensionValues.value.includes('"')) {
            fieldElement.value = dimensionValues.value;
        } else {
            fieldElement.value = parseFloat(dimensionValues.value).toFixed(4);
        }
    }

    fieldElement.name = dimensionLabel;
    fieldElement.id = 'dimension_' + dimensionLabel;
    fieldElement.className = 'dimension-field';

    dimensionContainer.appendChild(fieldElement);

    // Add cut type.
    if (dimensionValues.cut) {
        const cut = document.createElement('div');
        cut.innerText = dimensionValues.cut;
        cut.className = 'cut';

        dimensionContainer.appendChild(cut);
    }

    // Add tolerance
    if (dimensionValues.tolerance) {
        const tolerance = document.createElement('div');
        tolerance.innerText = dimensionValues.tolerance;
        tolerance.className = 'tolerance';

        dimensionContainer.appendChild(tolerance);
    }

    // Add error message.
    if (dimensionValues.error) {
        const error = document.createElement('p');
        error.className = 'error';
        error.innerText = dimensionValues.message;

        dimensionContainer.appendChild(error);
    }

    return dimensionContainer;
}


function updatePriceInfo(price) {
    if (price === 'demo') {
        return alert('Sign-up or log-in to get pricing');
    }

    if (!price || !price.total) {
        return $('.price-card').slideUp();
    }

    const each = parseFloat(price.each);

    $('#price_unit').text('$' + each.toFixed(2));
    $('#price_total').text('$' + price.total);

    const stockContainer = $('.info-row .stock').first();
    console.log('price', price);
    if (price.stock) {
        $('#stock_quantity').text(price.stock);
        stockContainer.slideDown()
    } else {
        stockContainer.slideUp();
    }


    $('.price-card').slideDown();
}


$.fn.formObject = function () {
    const formArray = this.serializeArray();

    let returnObject = {
        options: [],
        dimensions: {},
    };

    const urlParams = new URLSearchParams(window.location.search);
    let materialId = urlParams.get('material');

    if (materialId && formArray.length === 0) {
        returnObject.options.push(materialId);
    }

    for (let i = 0; i < formArray.length; i++) {
        if (formArray[i]['value']) {
            if (formArray[i]['name'] === 'options') {
                returnObject.options.push(formArray[i]['value']);
            } else if (dimensionTokens.includes(formArray[i]['name'])) {
                returnObject.dimensions[formArray[i]['name']] = formArray[i]['value'];
            } else {
                returnObject[formArray[i]['name']] = formArray[i]['value'];
            }
        }
    }

    return returnObject;
}


function addToCart() {
    $.post({
        url: '/api/configurator/add-to-cart',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(
            $('#graphimator_form').formObject()
        ),
        success: (response) => {
            // Show add-to-cart banner
            $('.added-to-cart-banner-container').addClass('active');

            setTimeout(() => {
                $('.added-to-cart-banner-container').removeClass('active');
            }, 3000);


            // Show cart count number indicator
            const cartButton = $('.cart-button');

            if (!cartButton.hasClass('has-items')) {
                cartButton.addClass('has-items');
            }

            document.styleSheets[0].insertRule(
                'a.cart-button.has-items:after { content: "' + response.quantity + '" }',
                document.styleSheets[0].cssRules.length
            );

            // Clear quantity & dimension fields
            $('.graphimator-card.quantity-card input').val('');

            if (!response.item.electrode) {
                response.item.electrode = '';
            }
            if (!response.item.burn) {
                response.item.burn = '';
            }
            if (!response.item.job) {
                response.item.job = '';
            }

            const cartItemMarkup = `
            <div class="cart-hover-item-container" data-item="${response.item.id}">
                <div class="remove-item" data-item="${response.item.id}">
                    <img src="/assets/img/white-trashcan.svg" class="remove-item-icon">
                </div>

                <div class="upper">
                    <div class="item-title">
                        ${response.item.title}
                    </div>
                </div>
                
                <div class="middle">
                    <div>
                        Electrode: <br>${response.item.electrode}
                    </div>

                    <div>
                        Job: <br>${response.item.job}
                    </div>

                    <div>
                        Burn: <br>${response.item.burn}
                    </div>
                </div>

                <div class="lower">
                    <div class="qty">
                        Qty: ${response.item.qty}
                    </div>

                    <div class="cost">
                        Individual Cost: $${response.item.price}
                    </div>
                </div>
            </div>
            `;

            if (response.quantity === 1) {
                $('.cart-hover-container-body').html(cartItemMarkup);
            } else {
                console.log(response.quantity)
                $('.cart-hover-container-body').append(cartItemMarkup);
            }

            $('.cart-hover-container .item-count').text(response.quantity);
            $('.cart-hover-container .subtotal').text(response.item.subtotal);

        },
        error: e => {
            handleError(e);
        }
    });
}
